<template>

    <fieldset class="ecm-filters ecm-map-settings">

        <legend> {{ $t("mapSettings") }} </legend>

        <div v-if="baseLayers" class="ecm-form-group ecm-form-group-select m-h">
            <label for="baseLayer" class="label-lg"> {{ $t("baseMaps") }} </label>
            <select id="baseLayer" @change="baseLayerChange($event)">
                <option
                    v-for="(baseLayer, index) in baseLayers"
                    :key="index"
                    :value="index">
                    {{ $t(baseLayer.name) }}
                </option>
            </select>
        </div>
    
        <div v-if="overlayLayers && overlayLayers.length" class="ecm-form-group">
            <label class="label-lg m-h"> {{ $t("overlayLayers") }} </label>

            <ul class="ecm-filters-list">

                <li
                    v-for="overlayLayer in overlayLayers"
                    :key="'overlay-layer-' + overlayLayer.name"
                    class="ecm-form-group-cb">
                    <label v-bind:for="'overlay-layer-' + overlayLayer.name">
                        {{ $t(overlayLayer.name) }}
                    </label>
                    <input
                        v-model="overlayLayer.checked"
                        @change="overlayLayerChange()"
                        :id="'overlay-layer-' + overlayLayer.name"
                        :value="true"
                        type="checkbox"
                        class="ecm-checkbox" />
                </li>

            </ul>

        </div>

        <div v-if="mapZoom != null" class="ecm-form-group ecm-form-group-range m-h">
            <label for="zoom" class="label-lg"> {{ $t("mapZoom") }} </label>
            <div class="ecm-range-labels">
                <span>-</span>
                <span> {{ mapZoom }} </span>
                <span>+</span>
            </div>
            <input
                id="zoom"
                type="range"
                @change="zoomChange($event)"
                :value="mapZoom"
                step="1"
                :min="mapMinZoom"
                :max="mapMaxZoom" />
        </div>

        <div class="ecm-form-group m-h">
            <button
                @click="getLocation"
                class="my-location-btn"
                :class="{ loading: gettingUserLocation}">
                <SvgIcon 
                    icon="icon-location"
                    :title="myLocationShowLabel">
                </SvgIcon>
                {{ myLocationShowLabel }}
            </button>
        </div>

        <div v-if="userLocation" class="ecm-form-group m-h">
            <input
                id="followUser"
                v-model="followUser"
                type="checkbox"
                class="ecm-checkbox"
                :value="true" />
            <label for="followUser"> {{ $t("myLocationCenter") }} </label>
        </div>

    </fieldset>

</template>

<script>
import {eventBus} from '../main.js';
import { store } from '../store/store';
import SvgIcon from './SvgIcon.vue';

export default {
    name: 'MapSettings',
    components: {
        SvgIcon
    },
    data() {
        return {
            mapZoom: null,
            mapMinZoom: 1,
            mapMaxZoom: 20
        }
    },
    store: store,
    computed: {
        baseLayers() {
            return store.state.config.mapLayers;
        },
        overlayLayers: {
            get() {
                return store.state.config.overlayLayers;
            },
            set(value) {
                this.$store.commit('setOverlayLayers', value)
            }
        },
        gettingUserLocation() {
            return store.state.gettingUserLocation;
        },
        myLocationShowLabel() {
            return this.$t("myLocationShow");
        },
        userLocation() {
            return this.$store.state.userLocation;
        },
        followUser: {
            get() {
                return this.$store.state.followUser;
            },
            set(value) {
                this.$store.commit('setFollowUser', value);
                if (value) {
                    eventBus.$emit('setMapCenter', this.userLocation);
                }
            }
        }
    },
    created() {
        eventBus.$on('mapZoomChanged', (zoom) => {
            this.mapZoom = zoom;
        });
        eventBus.$on('mapMinZoomChanged', (minZoom) => {
            this.mapMinZoom = minZoom;
        });
        eventBus.$on('mapMaxZoomChanged', (maxZoom) => {
            this.mapMaxZoom = maxZoom;
        });
    },
    methods: {
        baseLayerChange(e) {
            eventBus.$emit('setBaseLayer', this.baseLayers[e.target.value]);
        },
        overlayLayerChange() {
            // Set overlayLayers null first to trigger reactivity
            // Otherwise it won't update correctly if config is
            // set from Dashboard (dunno why but this seems to fix it)
            let tmp = this.overlayLayers;
            this.$store.commit('setOverlayLayers', null);
            this.$store.commit('setOverlayLayers', tmp);
        },
        zoomChange(e) {
            eventBus.$emit('setMapZoom', e.target.value);
        },
        getLocation() {
            eventBus.$emit('getLocation');
        }
    }
}

</script>

<style scoped>
.my-location-btn {
    display: block;
    width: 100%;
    padding: .5rem 1rem .3rem .5rem !important;
}
.my-location-btn > div {
    position: relative;
    top: -1px;
}
.my-location-btn::before {
    position: absolute;
    left: 50%;
    margin: 0 0 0 -10px !important;
    
}
</style>
